/*
 * This file is part of glowingblue/orell-facade.
 *
 * Copyright (c) 2023 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import BannerImage from '../components/BannerImage';
import BannerLinkButton from '../components/BannerLinkButton';
import BannerTeaser from '../components/BannerTeaser';
import BannerTitle from '../components/BannerTitle';
import Disruptor from '../components/Disruptor';
import LinkWrapper from '../components/LinkWrapper';
import AbstractLayout from './AbstractLayout';
import BannerSubtitle from '../components/BannerSubtitle';

// Text and button on the left, image on the right.
export default class ThaliaAbstractBasicLayout extends AbstractLayout {
	content() {
		const { banner } = this.attrs;
		const backgroundColor = banner.visual()?.bg_color?.default;

		return (
			<LinkWrapper banner={banner}>
				<div className="Banner-content" style={{ '--banner-bg': backgroundColor }}>
					<div className="BannerContentContainer">
						<BannerTitle banner={banner} />
						<BannerSubtitle banner={banner} />
						<BannerTeaser banner={banner} />
						<BannerLinkButton banner={banner} />
					</div>

					<div className="BannerImageWrapper">
						<BannerImage banner={banner} />
						<Disruptor banner={banner} />
					</div>
				</div>
			</LinkWrapper>
		);
	}
}
